import React, { useState, useEffect } from "react"; // 1. Import useState and useEffect
import "./Skills.css";

// 2. Define the original, ordered list of skills. This is our source of truth.
const originalSkills = [
  "C#",
  "Python",
  "JavaScript",
  "PHP",
  "HTML5",
  "CSS3",
  "VB.NET",
  "SQL",
  "MSSQL",
  "GCS",
  "GCP",
  "Azure",
  "GCP",
  "DevOps",
  "CI/CD",
  "Docker",
  "Linux",
  "VPS",
  "ASP.Net",
  "MVVM",
  "APIs",
  "Entity Framework",
  "Git",
  "React",
  "QGIS",
  "Photoshop",
  "Video Editing",
  "Crystal Reports",
  "Agile",
  "LLMs",
  "Windows Forms",
  "LAMP",
  "Technical Writing",
];
function Skills() {
  // 3. Set up a state variable to hold the shuffled skills.
  // It starts as an empty array.
  const [shuffledSkills, setShuffledSkills] = useState([]);

  // 4. Use the useEffect hook to shuffle the array ONCE when the component mounts.
  useEffect(() => {
    // Create a copy of the original array and then shuffle it.
    // The sort function with a random comparator is a concise way to shuffle.
    const shuffled = [...originalSkills].sort(() => 0.5 - Math.random());

    // Update the state with the newly shuffled array.
    setShuffledSkills(shuffled);
  }, []); // The empty dependency array [] ensures this effect runs only once.

  return (
    <section id="skills" className="section">
      <div className="container">
        <h2 className="section-title">My Skills</h2>
        <div className="skills-grid">
          {/* 5. Map over the 'shuffledSkills' state variable to render the badges. */}
          {shuffledSkills.map((skill) => (
            <div key={skill} className="skill-badge">
              {skill}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
